import VericalList from "component/list/Vertical";
import CommonGamesList from "component/list/CommonGames";
import Games4by2 from "component/list/Games4by2";
import GamesList from "component/list/Games";
import CategoryGames from "component/list/CategoryGames";
import TableList from "component/list/TableList";
import FilterList from "component/list/FilterList";

export { VericalList };
export { CommonGamesList };
export { Games4by2 };
export { GamesList };
export { CategoryGames };
export { TableList };
export { FilterList };

export default Object.assign({
  VericalList,
  CommonGamesList,
  Games4by2,
  GamesList,
  CategoryGames,
  TableList,
  FilterList,
});
